export default __webpack_public_path__ + "static/media/belop_Page_1.0b9c4789.png";